import TheOrders from '@/views/orders/TheOrders';
import OrderView from '@/views/orders/show/OrderShow';
import OrderEdit from '@/views/orders/edit/OrderEdit';
import Editinformation from '@/views/orders/edit/OrderEditinformation';
import EditClient from '@/views/orders/edit/OrderEditClient';
import EditComissions from '@/views/orders/edit/OrderEditComission';
import EditRefund from '@/views/orders/edit/OrderEditRefund';
import EditChargeback from '@/views/orders/edit/OrderEditChargeback';
import EditFiles from '@/views/orders/edit/files/OrderFileEdit';
import FormFiles from '@/views/orders/edit/files/OrderFileForm';

export default [
    {
        path: '/orders',
        name: 'orders',
        component: TheOrders,
        meta: {
            requiresAuth: true,
            menuPage: 'orders',
            dontScrollUp: true
        },
        children: [
            {
                path: '/orders/:id_order/show',
                component: OrderView,
                meta: {
                    requiresAuth: true
                }
            }
        ],
    },
    {
        path: '/orders/:id_order/',
        component: OrderEdit,
        meta: {
            requiresAuth: true,
            menuPage: 'orders'
        },
        props:{
            header: true,
            content: true,
        },
        children: [
            {
                path: '/orders/:id_order/',
                component: Editinformation,
                children: [
                    {
                        path: '/orders/:id_order/client',
                        component: EditClient
                    }
                ]
            },
            {
                path: '/orders/:id_order/tax-and-comissions',
                component: EditComissions
            },
            {
                path: '/orders/:id_order/refund',
                component: EditRefund
            },
            {
                path: '/orders/:id_order/chargeback',
                component: EditChargeback,
                name: 'replyChargeback',
            },
            {
                path: '/orders/:id_order/files',
                component: EditFiles,
                children: [
                    {
                        path: '/orders/:id_order/files/:file',
                        component: FormFiles,
                    }
                ]
            }
        ]
    }
];